export function getIsTopUpEnabled({ countryCode }: { countryCode: string | undefined }) {
  if (import.meta.env.DEV || import.meta.env.VITE_TEST) {
    return true;
  }
  return countryCode === "NZ";
  // return false;
}
